/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrgQueryResult from './OrgQueryResult';

/**
 * The OrgOutputOrg model module.
 * @module model/OrgOutputOrg
 * @version 1.0
 */
class OrgOutputOrg {
    /**
     * Constructs a new <code>OrgOutputOrg</code>.
     * @alias module:model/OrgOutputOrg
     */
    constructor() { 
        
        OrgOutputOrg.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrgOutputOrg</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrgOutputOrg} obj Optional instance to populate.
     * @return {module:model/OrgOutputOrg} The populated <code>OrgOutputOrg</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrgOutputOrg();

            if (data.hasOwnProperty('org')) {
                obj['org'] = OrgQueryResult.constructFromObject(data['org']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/OrgQueryResult} org
 */
OrgOutputOrg.prototype['org'] = undefined;






export default OrgOutputOrg;

